var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exchange-detail detail-padding" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "common-card" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "common-table",
            attrs: { data: _vm.tableList, "highlight-current-row": "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "number", label: "Number", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var $index = ref.$index
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.queryParams.total -
                              ((_vm.queryParams.page - 1) *
                                _vm.queryParams.pageSize +
                                $index)
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "amount",
                label: "Cumulative investment Token",
                align: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        [
                          _c("big-number", {
                            attrs: { number: row.amount },
                            on: {
                              "update:number": function ($event) {
                                return _vm.$set(row, "amount", $event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "td-word-sm" }, [
                            _vm._v(_vm._s(row.type)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "lmtAmt", label: "Token Status", align: "right" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "status",
                          class: row.status == "1" ? "Returned" : "Consumed",
                        },
                        [
                          _c("i", { staticClass: "iconfont trn-xiaohao" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                row.status == "1" ? "Returned" : "Consumed"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("pagination", {
          attrs: {
            total: _vm.queryParams.total,
            page: _vm.queryParams.page,
            limit: _vm.queryParams.pageSize,
          },
          on: {
            "update:total": function ($event) {
              return _vm.$set(_vm.queryParams, "total", $event)
            },
            "update:page": function ($event) {
              return _vm.$set(_vm.queryParams, "page", $event)
            },
            "update:limit": function ($event) {
              return _vm.$set(_vm.queryParams, "pageSize", $event)
            },
            pagination: function ($event) {
              return _vm.getList()
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "spaceBetween",
        staticStyle: { "margin-bottom": "0.24rem" },
      },
      [
        _c("div", { staticClass: "spaceLeft" }, [
          _c("div", { staticClass: "detail-title-1" }, [
            _vm._v("My Bid History"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "spaceLeft search-form" }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }